<template>
    <div>
        <label :for="inputID" :class="[{'with-desc': !!description}]">{{label}}</label>
        <div v-if="description !== ''" class="description-block">
            <p>{{description}}</p>
        </div>
        <input type="text" class="lm-input"
               :id="inputID"
               :value="value"
               :placeholder="placeholder"
               @input="handleInput"
        />
    </div>
</template>
<script>
    export default {
        name: 'LoveMapInput',
        props: {
            placeholder: {
                type: String,
            },
            description: {
                type: String,
                default: ''
            },
            label: {
                type: String,
            },
            value:{

            }
        },
        data() {
            return {
                val: ''
            }
        },
        created() {
            this.val = this.value
        },
        computed: {
            inputID() {
                return `input-id-${this._uid}`;
            }
        },
        methods: {
            handleInput(e) {
                this.$emit('input', e.target.value)
            },
        }
    }
</script>

<style scoped lang="scss">
    label{
        &.with-desc{
            margin-bottom: -5px;
        }
    }
    .description-block{
        text-align: left;
        p {
            margin-top: -3px;
            margin-bottom: 0;
            font-style: italic;
            vertical-align: baseline;
            display: inline-block;
            font-size: 10px;
            color: #444444;
        }
    }
</style>

